// import { isExpired, decodeToken } from 'react-jwt';

export async function isTokenOk (token) {    
    if (!token || token === undefined) {
        return false;
    }

    /*
    const decoded = decodeToken(token);
    console.log('Token Decoed', decoded);

    if (isExpired(token)) {
        return false;
    }
    */
    return true;
}

export function getTokenPayload (token) {
    return {}; //decodeToken(token);
}
